// DiagnosticEntrepreneurWrapperPage.jsx
// Page Diagnostic Entrepreneur dans le contexte Espace Pro Abracadabati
// Affiche le contenu original SANS le header/footer BatiAssist

import UnifiedHeader from '../../components/layout/UnifiedHeader';
import EspaceProNav from '../../components/layout/EspaceProNav';

// Import du contenu original de la page Diagnostic
import DiagnosticEntrepreneurPage from '../DiagnosticEntrepreneurPage';

export default function DiagnosticEntrepreneurWrapperPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="diagnostic-wrapper-page">
      {/* Header Abracadabati */}
      <UnifiedHeader />
      
      
      {/* Sous-navigation Espace Pro */}
      <EspaceProNav />
      
      {/* Contenu de la page Diagnostic */}
      <main>
        <DiagnosticEntrepreneurPage />
      </main>
    </div>
  );
}
